// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"325":"e4c7e20f","535":"83d6fe06"}[chunkId] + ".chunk.css";
};